<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>内部管理</el-breadcrumb-item>
            <el-breadcrumb-item>训练平板</el-breadcrumb-item>
            <el-breadcrumb-item>游戏列表</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- Tabs -->
        <el-tabs v-model="activeName" type="border-card">
          <!-- 游戏列表 strat -->
          <el-tab-pane name="first" label="游戏列表">
            <!-- 筛选条件 start -->
            <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
              <el-form-item label="">
                <el-select v-model="keywords.sortid" placeholder="请选择游戏分类" class="select">
                  <el-option
                    v-for="item in sortList" :key="item.Name" :label="item.Name" :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="keywords.isgood" placeholder="请选择" class="select"  style="width: 200px;">
                  <el-option label="请选择是否精品" value="0"></el-option>
                  <el-option label="是精品" value="1"></el-option>
                  <el-option label="不是精品" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="keywords.ishot" placeholder="请选择" class="select"  style="width: 200px;">
                  <el-option label="请选择是否热点" value="0"></el-option>
                  <el-option label="是热点" value="1"></el-option>
                  <el-option label="不是热点" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入游戏名称" style="width: 150px;"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="clicksearch">查询</el-button>
              </el-form-item>
            </el-form>
            <!-- 筛选条件 end -->
            <el-table :data="dataList" border stripe>
              <el-table-column prop="Id" label="编号" width="80px"></el-table-column>
              <el-table-column prop="Rank" label="排序" width="80px"></el-table-column>
              <el-table-column prop="Isgoods" label="是否精品" width="80px"></el-table-column>
              <el-table-column prop="Ishots" label="是否热点" width="80px"></el-table-column>
              <el-table-column prop="Name" label="游戏名称"></el-table-column>
              <el-table-column prop="Icon" label="游戏图标"></el-table-column>
              <el-table-column prop="Bigicon" label="游戏热点图标"></el-table-column>
              <el-table-column prop="Url" label="游戏链接"></el-table-column>
              <el-table-column prop="Video" label="视频讲解"></el-table-column>
              <el-table-column prop="Info" label="游戏描述"></el-table-column>
              <el-table-column prop="Createtime" label="创建时间" width="200px"></el-table-column>
              <el-table-column prop="operation" label="操作" width="200px">
                <template v-slot="scope">
                  <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickModify(scope.$index,scope.row)">修改</el-button>
                  <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelete(scope.$index,scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 修改游戏分类弹出框 start -->
            <el-dialog title="修改游戏分类" :visible.sync="modify" width="30%" :close-on-click-modal="false">
              <el-form :model="editForm" ref="editFormRef" label-width="70px">
                <el-form-item label="排序" class="addAdminForm">
                  <el-input v-model="editForm.rank" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="游戏分类" class="addAdminForm">
                  <el-select v-model="editForm.sortid" placeholder="请选择游戏分类" class="select" style="width: 350px;">
                    <el-option
                      v-for="item in sortList" :key="item.Name" :label="item.Name" :value="item.Id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否精品">
                  <el-select v-model="editForm.isgood" placeholder="请选择" class="select"  style="width: 200px;">
                    <el-option label="是精品" value="1"></el-option>
                    <el-option label="不是精品" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否热点">
                  <el-select v-model="editForm.ishot" placeholder="请选择" class="select"  style="width: 200px;">
                    <el-option label="是热点" value="1"></el-option>
                    <el-option label="不是热点" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="游戏名称" class="addAdminForm">
                  <el-input v-model="editForm.name" placeholder="请输入游戏名称"></el-input>
                </el-form-item>
                <el-form-item label="游戏图标" class="addAdminForm">
                  <el-input type="textarea" v-model="editForm.icon" placeholder="请输入游戏图标"></el-input>
                </el-form-item>
                <el-form-item label="游戏热点图标" class="addAdminForm">
                  <el-input type="textarea" v-model="editForm.bigicon" placeholder="请输入游戏热点图标"></el-input>
                </el-form-item>
                <el-form-item label="游戏链接" class="addAdminForm">
                  <el-input type="textarea" v-model="editForm.url" placeholder="请输入游戏链接"></el-input>
                </el-form-item>
                <el-form-item label="视频讲解" class="addAdminForm">
                  <el-input type="textarea" v-model="editForm.video" placeholder="请输入视频讲解"></el-input>
                </el-form-item>
                <el-form-item label="游戏描述" class="addAdminForm">
                  <el-input type="textarea" v-model="editForm.info" placeholder="请输入游戏描述"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="clickedit">保存</el-button>
                </el-form-item>
              </el-form>
            </el-dialog>
            <!-- 修改游戏分类弹出框 end -->

          </el-tab-pane>
          <!-- 游戏列表 end -->

          <!-- 添加游戏 start -->
          <el-tab-pane name="second" label="添加游戏">
            <el-form :model="addForm" ref="addFormRef" label-width="70px">
              <el-form-item label="排序" class="addAdminForm">
                <el-input v-model="addForm.rank" placeholder="请输入排序"></el-input>
              </el-form-item>
              <el-form-item label="游戏分类" class="addAdminForm">
                <el-select v-model="addForm.sortid" placeholder="请选择游戏分类" class="select" style="width: 350px;">
                  <el-option
                    v-for="item in sortList" :key="item.Name" :label="item.Name" :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="游戏名称" class="addAdminForm">
                <el-input v-model="addForm.name" placeholder="请输入游戏名称"></el-input>
              </el-form-item>
              <el-form-item label="游戏图标" class="addAdminForm">
                <el-input v-model="addForm.icon" placeholder="请输入游戏图标"></el-input>
              </el-form-item>
              <el-form-item label="游戏链接" class="addAdminForm">
                <el-input type="textarea" v-model="addForm.url" placeholder="请输入游戏链接"></el-input>
              </el-form-item>
              <el-form-item label="视频讲解" class="addAdminForm">
                <el-input type="textarea" v-model="addForm.video" placeholder="请输入视频讲解"></el-input>
              </el-form-item>
              <el-form-item label="游戏描述" class="addAdminForm">
                <el-input type="textarea" v-model="addForm.info" placeholder="请输入游戏描述"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="clickadd">添加</el-button>
                <el-button type="info" @click="clickreturn">返回</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 添加游戏 end -->
        </el-tabs>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyTrainpadGamelist',
  data () {
    return {
      activeName: 'first',
      addForm: {
        rank: '',
        sortid: '',
        name: '',
        icon: '',
        url: '',
        video: '',
        info: ''
      },
      editForm: {
        id: '',
        rank: '',
        sortid: '',
        isgood: '',
        ishot: '',
        name: '',
        icon: '',
        bigicon: '',
        url: '',
        video: '',
        info: ''
      },
      sortList: [],
      dataList: [],
      modify: false,
      keywords: {
        sortid: 1,
        name: '',
        isgood: '0',
        ishot: '0'
      }
    }
  },
  mounted () {
    this.apiGetTrainPadGameSortlist()
    this.apiGetTrainPadGameList()
  },
  methods: {
    clicksearch () {
      this.apiGetTrainPadGameList()
    },
    clickDelete (index, row) {
      this.$confirm('是否删除此游戏?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteTrainPadGameList(row.Id)
      })
    },
    clickadd () {
      if (!this.addForm.rank) {
        this.$alert('请输入排序', '提示')
        return
      }
      if (!this.addForm.name) {
        this.$alert('请输入游戏名称', '提示')
        return
      }
      if (!this.addForm.icon) {
        this.$alert('请输入游戏图标', '提示')
        return
      }
      this.apiAddTrainPadGameList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickModify (index, row) {
      this.editForm.id = row.Id
      this.editForm.rank = row.Rank
      this.editForm.sortid = row.Sortid
      this.editForm.isgood = row.Isgood.toString()
      this.editForm.ishot = row.Ishot.toString()
      this.editForm.name = row.Name
      this.editForm.icon = row.Icon
      this.editForm.bigicon = row.Bigicon
      this.editForm.url = row.Url
      this.editForm.video = row.Video
      this.editForm.info = row.Info
      this.modify = true
    },
    clickedit () {
      if (!this.editForm.rank) {
        this.$alert('请输入排序', '提示')
        return
      }
      if (!this.editForm.name) {
        this.$alert('请输入分类名称', '提示')
        return
      }
      if (!this.editForm.icon) {
        this.$alert('请输入分类图标', '提示')
        return
      }
      this.apiEditTrainPadGameList()
    },
    apiGetTrainPadGameSortlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetTrainPadGameSortlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.sortList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetTrainPadGameList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        sortid: that.keywords.sortid,
        name: that.keywords.name,
        isgood: that.keywords.isgood,
        ishot: that.keywords.ishot
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetTrainPadGameList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddTrainPadGameList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        rank: this.addForm.rank,
        sortid: this.addForm.sortid,
        name: this.addForm.name,
        icon: this.addForm.icon,
        url: this.addForm.url,
        video: this.addForm.video,
        info: this.addForm.info
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddTrainPadGameList, Qs.stringify(data))
        .then(function (response) {
          that.apiGetTrainPadGameList()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditTrainPadGameList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.editForm.id,
        rank: this.editForm.rank,
        sortid: this.editForm.sortid,
        isgood: this.editForm.isgood,
        ishot: this.editForm.ishot,
        name: this.editForm.name,
        icon: this.editForm.icon,
        bigicon: this.editForm.bigicon,
        url: this.editForm.url,
        video: this.editForm.video,
        info: this.editForm.info
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditTrainPadGameList, Qs.stringify(data))
        .then(function (response) {
          that.apiGetTrainPadGameList()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.modify = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteTrainPadGameList: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteTrainPadGameList, Qs.stringify(data))
        .then(function (response) {
          that.apiGetTrainPadGameList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
